import React from "react";
import { connect } from "react-redux";
import { Redirect } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import axios from 'axios';
import { kinetik_api_url } from '../utilities/const';
import {setProviderInfo} from '../login_page/login.action';
import { bindActionCreators } from "redux";




class IntitialRequests extends React.Component {
 
  componentWillMount=()=>{
        let token = localStorage.getItem('authToken');
        if(token!=null){
            this.getProviderInfo(localStorage.getItem('authToken'))

        }
  }
  render=()=> {
   
   
      return (
        <div>
        </div>
      );
  }

  
  getProviderInfo=(authToken)=>{
        const userID = jwtDecode(authToken).user_id;
        return new Promise((resolve, reject) => {
           axios.get(kinetik_api_url + '/get_boarding_info/' + userID).then(res=>{
            localStorage.setItem('payers',res.data.result.company_payers);
            // parse JSON for companybrokers, companypayers
            let processCompanyPayer = res.data.result.company_payers.length !== 0 ?
             JSON.parse(res.data.result.company_payers) : [];
            let processCompanyBroker = res.data.result.company_brokers.length !== 0 ?
             JSON.parse(res.data.result.company_brokers) : [];
            res.data.result.company_payers = processCompanyPayer;
            res.data.result.company_brokers = processCompanyBroker;
            this.props.setProviderInfo(res.data.result);
            localStorage.setItem('bill_npi',res.data.result.company_billing_npi)
            resolve("done")
            }).catch(err=>{
            console.log("err from getting onboarding info",err)
            resolve(err)
            })
        })
  }
}

const mapStateToProps = state => {
  return {
  };
};
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setProviderInfo
    },
    dispatch
  );
}

export default connect(mapStateToProps,mapDispatchToProps)(IntitialRequests);



// WEBPACK FOOTER //
// ./src/app/common/InitialRequests.js